import { styled } from '@mui/material/styles'

export const PanelWrapper = styled('div', {
  name: 'PanelWrapper',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  flex-grow: 1;
  position: relative;
`
